<template>
  <div class="wrapper">
    <vue-plyr :options="player_settings">
      <div
        data-plyr-provider="youtube"
        :data-plyr-embed-id="url"
        style="--plyr-color-main:#36B34A"
      ></div>
    </vue-plyr>
  </div>
</template>

<script>
export default {
  name: 'GalleryYoutubeEmbed',
  props: {
    id: {
      type: String,
      default() {
        return `youtube-embed-${this._uid}`
      },
    },
    url: {
      type: String,
      required: true,
      validator(value) {
        return (
          value.match(
            /(?:https?:\/{2})?(?:w{3}\.)?youtu(?:be)?\.(?:com|be)(?:\/watch\?v=|\/)([^\s&]+)/,
          ) !== null
        )
      },
    },
  },
  data() {
    return {
      player_settings: {
        controls: [
          'play-large',
          'play',
          'progress',
          'current-time',
          'volume',
          'mute',
          'fullscreen',
        ],
      },
    }
  },
}
</script>

<style>
.wrapper {
  width: 100%;
  height: 100%;
}
</style>
